import type { ExtensionComponentProps } from '@atlaskit/editor-common/extensions';
import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { NativeTabsParameters } from '../src/nativeTabsTypes.ts';

export const TabsRenderer: LoadableType<ExtensionComponentProps<NativeTabsParameters>> =
	LoadablePaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-TabsRenderer" */ '../src/components/TabsRenderer.tsx'
				)
			).TabsRenderer,
	});
